import React from "react"
import Svg from "../../../../_svgs/svg"
import * as path from "../../../../../booking/constants/Paths"

function Booking(props) {
  return (
    <div className={`stylish-table__row stylish-table__row--body ${props.sourceTable}`}>
      <div className="stylish-table__cell v--desktop-only">
        <div>
          <span>
            <strong>{props.status}</strong>
          </span>
        </div>
      </div>
      <div className="stylish-table__cell v--desktop-only">
        <div>
          <span>{props.convertBookingTime(props.bookingDate)}</span>
        </div>
      </div>
      <div className="stylish-table__cell">
        <div>
          <span>{props.bookingNo}</span>
        </div>
      </div>
      <div className="stylish-table__cell">
        <div>
          <span>{props.convertBookingTime(props.arrivalTime)}</span>
        </div>
      </div>
      <div className="stylish-table__cell">
        <div>
          <span>{props.convertBookingTime(props.departureTime)}</span>
        </div>
      </div>
      <div className="stylish-table__cell v--desktop-only">
        <div>
          <span>{props.carpark}</span>
        </div>
      </div>
      <div className="stylish-table__cell v--desktop-only">
        <div>
          <span>{props.price}</span>
        </div>
      </div>
      <div className="stylish-table__cell v--desktop-only">
        <div>
          <span>{props.licenceplate}</span>
        </div>
      </div>
      <div className="stylish-table__cell inner-padding--svg">
        <a
          href={`${path.AMMEND_SHOW_BOOKING(props.lang)}?email=${props.customerEmail}&reference=${props.bookingNo}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Svg iconName={"arrowrightangle"} />
        </a>
      </div>
    </div>
  )
}

export default Booking
